import 'bootstrap.collapse';
import 'configure-default-runtime';
import 'global';
import { onLoad } from 'runtime';
import '/assets/theme/js/mmenu-light.js?v=2';
import { initializeDesktopNavigation } from '/assets/theme/js/desktop-navigation.js?v=1';

initializeDesktopNavigation(document.querySelector('#menu-navbar'));

const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 991px)');

menu.navigation({
    slidingSubmenus: true,
    title: 'Menu'
});

const drawer = menu.offcanvas({
    position: 'left'
});

// Open the menu.
document.querySelector('button[data-target="#menu-navbar"]')
    .addEventListener('click', () => {
        drawer.open();
    });

onLoad(context => {
    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const href = link.getAttribute('href');
            const offsetTop = context.querySelector(href).offsetTop;

            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });

    //If sticky box height is greater than device height change it to static
    var stickyBox = context.querySelector('.sticky-box');

    if (window.innerWidth >= 991 && stickyBox && stickyBox.offsetHeight > window.innerHeight)
        stickyBox.style.position = 'static';

    // plus and minus buttons for shop
    context.querySelectorAll('.adjust-quantity').forEach(button => {
        button.addEventListener('click', () => {
            const closestQuantity = button.closest('.sp-quantity');
            const input = closestQuantity.querySelector('input');

            input.value = +input.value + 1 * +button.getAttribute('data-multi');

            if (+input.value < 0) {
                input.value = 0;
            }
        });
    });

    // Trying to add a delay of the car parts menu hover for each li.
    const listItems = context.querySelectorAll('#menu-navbar .dropdown-main .dropdown-menu li');
    let hoverTimeout;
    let currentActive = null;

    if (listItems.length > 0) {
        currentActive = listItems[0]; // Initially, the first <li> is active
        currentActive.classList.add('active');
    }

    listItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            clearTimeout(hoverTimeout);

            // Check if the current item is different from the active one
            if (item !== currentActive && !currentActive.contains(item)) {
                hoverTimeout = setTimeout(() => {
                    // Remove active class from the previously active list item
                    currentActive.classList.remove('active');

                    // Add active class to the hovered list item
                    item.classList.add('active');

                    // Update the current active item
                    currentActive = item;
                }, 100); // Wait for 100 milliseconds before switching
            }
        });

        item.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimeout);
        });
    });
});
